const user = {
  state: {
    userDetal: {},
    accessToken: "",
    appToken: "",
    openFlag: false
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, token) => {
      state.accessToken = token;
    },
    SET_APP_TOKEN: (state, token) => {
      state.appToken = token;
    },
    SET_USER_DETAL: (state, obj) => {
      state.userDetal = obj;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    SET_OPENFLAG: (state, openFlag) => {
      state.openFlag = openFlag;
    }
  },

  actions: {}
};

export default user;
